<template>
  <div class="home-box">
    <div class="box">
      <div class="box-title">
        <div :class="active==index?'title-active':''" :key="index" @click="activeIndex(item,index)" v-for="(item,index) in typeList">{{item.name}}</div>
      </div>
      <div class="box-title1">
        <div class="t1-l">
          <div class="t1-l-in">
            <el-date-picker
              size="small"
              v-model="search.createTime"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              placeholder="选择日期">
            </el-date-picker>
          </div>
          <div class="btn" style="margin-left:10px" @click="getData">搜索</div>
        </div>
        <div v-if="isMenuExit('pro:party:add')" class="t1-r btn" @click="enter">新增</div>
      </div>
      <div class="scroll">
        <div class="s-item" @click="enter1(item)" v-for="(item,index) in dataList" :key="index">
          <div>{{item.newsTitle}}</div>
          <div v-html="item.newsContent"></div>
          <div>
            <img :src="item1" alt="" v-for="(item1,index) in dataList[index].imgContent" :key="index">
          </div>
          <div>
            <div class="ll">
              <div>{{item.newsType}}</div>
              <div>{{item.createDate}}</div>
              <div>{{item.personCount}}参与</div>
            </div>
            <div class="rr">
              {{item.viewCount}} 浏览
            </div>
          </div>
        </div>
        <div class="zw" v-if="dataList.length==0">暂无数据</div>
      </div>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="search.pageNum"
      :page-sizes="[10, 20, 40, 50, 100, 200]"
      :page-size="search.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        typeList: [
          {
            name:'全部',
            value:''
          },
          {
            name:'党员大会',
            value:1
          },
          {
            name:'支部会议',
            value:2
          },
          {
            name:'党小组会',
            value:3
          },
          {
            name:'党课',
            value:4
          },
          {
            name:'民主生活会',
            value:5
          },
          {
            name:'报告工作',
            value:6
          },
          {
            name:'党员汇报',
            value:7
          },
          {
            name:'民主评议',
            value:8
          },
          {
            name:'每周一课',
            value:9
          },
          {
            name:'党建活动',
            value:10
          },
          {
            name:'工会活动',
            value:11
          },
          {
            name:'其他',
            value:12
          },
        ],
        active:0,
        search:{
          newsType:'',
          projectId:util.session.get('groupId'),
          createTime:'',
          pageSize:10,
          pageNum:1,
          moduleType:'partyactive'
        },
        dataList:[],
        total:0,
        aa:base.httpCtx
      }
    },
    mounted(){
      this.getData()
    },
    methods:{
      isMenuExit(row){
            var flag = util.common.filterBtnMenu(row)
            return flag
        }, 
      handleSizeChange(val){
        this.search.pageSize = val
        this.search.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.search.pageNum = val
        this.getData()
      },
      getData(){
        myHttp.findInfo(this.search).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.total = res.data.data.pageInfo.total
            res.data.data.pageInfo.list.forEach((item,index)=>{
              // item.newsType = this.typeList[item.newsType].value
              this.typeList.forEach((itemA,indexA)=>{
                if(item.newsType==itemA.value){
                  item.newsType=itemA.name
                }
              })
              // let b = item.newsContent.replace(/\n/g,'<br>')
              // let aa = b.split('')
              // let bb = []
              // aa.forEach(itemA =>{
              //   if(itemA==' '){
              //     bb.push('&nbsp;')
              //   }else{
              //     bb.push(itemA)
              //   }
              // })
              // item.newsContent = bb.join('')
              if(item.imgContent!=''){
              let a = item.imgContent.split(',')
              item.imgContent = a
            }
            })
            this.dataList = res.data.data.pageInfo.list
            console.log(this.dataList)
          }
        })
      },
      activeIndex(item,index){
        this.search.newsType = item.value
        this.active=index
        this.getData()
      },
      enter(){
        this.$router.push({
          path:'/partyBuildingActivitiesAdd',
          query:{
            type:1
          }
        })
      },
      enter1(item){
        this.$router.push({
          path:'/partyBuildingActivitiesItem',
          query:{
            id:item.id
          }
        })
      }
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
  }
  .box-title{
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding-left:16px;
    display: flex;
  }
  .box-title>div{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 22px;
    cursor: pointer;
  }
  .box-title>div:hover{
    opacity: 0.7;
  }
  .title-active{
    border-bottom: 2px solid #4D6EB1;
  }
  .box-title1{
    margin-top:1.1vh;
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  .t1-l{
    height: 100%;
    display: flex;
  }
  .btn{
    width: 52px;
    height: 100%;
    border-radius: 4px;
    background: #3871E5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
  }
  .btn:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .scroll{
    height: 69.2vh;
    overflow: auto;
  }
  .s-item{
    margin-top: 10px;
    height: 30vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding: 16px;
    cursor: pointer;
  }
  .s-item:hover{
    opacity: 0.7;
  }
  .s-item>div:nth-child(1){
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    text-align: start;
    margin-bottom: 10px;
  }
  .s-item>div:nth-child(2){
    height: 7.8vh;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    color: #999999;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: start;
    margin-bottom: 10px; 
  }
  .s-item>div:nth-child(3){
    margin-bottom: 10px;
    height: 10.8vh;
    text-align: start;
  }
  .s-item>div:nth-child(3)>img{
    width: 150px;
    height: 100%;
    margin-right: 16px;
  }
  .s-item>div:nth-child(4){
    display: flex;
    height: 3vh;
    align-items: center;
    justify-content: space-between;
  }
  .ll{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .ll>div:nth-child(1){
    width: 82px;
    height: 100%;
    border-radius: 25px;
    background: #FA001F;
    font-family: SourceHanSansCN-Medium;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ll>div:nth-child(2){
    margin-left: 20px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
  }
  .ll>div:nth-child(3){
    margin-left: 20px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
  }
  .rr{
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #999999;
  }
  .zw{
    font-size: 20px;
    margin-top: 20vh;
  }
</style>